import { useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useGetCentroCusto(idExternoUnidade?: string, idExternoPeriodoSafra?: string) {
  return useQuery(
    [
      URL.PLANO_OPERACIONAL.OBTER_CENTRO_CUSTO_DROPDOWN_ID_EXTERNO,
      idExternoUnidade,
      idExternoPeriodoSafra
    ],
    async () => {
      const { data } = await http.get(URL.PLANO_OPERACIONAL.OBTER_CENTRO_CUSTO_DROPDOWN_ID_EXTERNO, {
        params: { idExternoUnidade, idExternoPeriodoSafra },
      });
      return data;
    },
    {
      enabled: !!idExternoUnidade && !!idExternoPeriodoSafra,
    }
  );
}

export default useGetCentroCusto;
